import { g as i } from "./createTheme-ef7fa3a1.js";
function o(r, s, a = "Mui") {
  const t = {};
  return s.forEach((e) => {
    t[e] = i(r, e, a);
  }), t;
}
export {
  o as g
};
//# sourceMappingURL=generateUtilityClasses-b12a03ea.js.map
